/**
 * /manage/credits — MOCK. Agent credit usage + top-ups.
 *
 * No credits backend exists; static mockup-faithful page. No API, no real state.
 */

import { createFileRoute } from "@tanstack/react-router";

import { Button } from "@/components/ui/button";
import { useDocumentTitle } from "@/lib/document-title";

export const Route = createFileRoute("/manage/credits")({
  component: CreditsPage,
});

const MONTHS: [string, number][] = [
  ["Dec", 60],
  ["Jan", 80],
  ["Feb", 72],
  ["Mar", 110],
  ["Apr", 95],
  ["May", 130],
];
const BREAKDOWN: [string, string][] = [
  ["Agent runs", "64%"],
  ["Canvas analysis", "21%"],
  ["Tagging & search", "9%"],
  ["Other", "6%"],
];

function CreditsPage() {
  useDocumentTitle(["Credits", "Manage"]);
  const max = Math.max(...MONTHS.map((m) => m[1]));
  return (
    <div className="plan-skin">
      <div className="mx-auto max-w-[920px] px-10 py-9">
        <div className="manage-head">
          <div className="crumb">MANAGE</div>
          <h1 className="page">Credits</h1>
          <p className="page-sub">Agent credit usage and top-ups.</p>
        </div>
        <hr className="rule" />

        <div className="manage-body">
          <div className="credit-stats">
            <div className="credit-stat">
              <div className="cs-v">5,000</div>
              <div className="cs-k">Total credits</div>
            </div>
            <div className="credit-stat">
              <div className="cs-v">3,140</div>
              <div className="cs-k">Consumed</div>
            </div>
            <div className="credit-stat">
              <div className="cs-v ok">1,860</div>
              <div className="cs-k">Remaining</div>
            </div>
          </div>

          <div className="settings-section">
            <div className="settings-section-h">Monthly consumption</div>
            <div className="credit-graph">
              {MONTHS.map(([m, v]) => (
                <div className="cg-col" key={m}>
                  <div className="cg-bar" style={{ height: `${(v / max) * 100}%` }}>
                    <span className="cg-val">{v}</span>
                  </div>
                  <div className="cg-label">{m}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="settings-section">
            <div className="settings-section-h">Usage breakdown</div>
            <div className="breakdown">
              {BREAKDOWN.map(([k, v]) => (
                <div className="bd-row" key={k}>
                  <span>{k}</span>
                  <span className="bd-bar">
                    <span style={{ width: v }} />
                  </span>
                  <span className="bd-pct">{v}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="hint">
            Credits are allocated monthly with your Team plan (5,000/mo). Unused credits roll
            over for 30 days.
          </div>
          <div className="settings-actions">
            <Button>Purchase additional credits</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
